<template>
<div class="content" v-loading="loading">
  <div class="header">
    <el-button @click="getCustomerExcel(1)">预览</el-button>
    <el-button @click="getCustomerExcel(0)">导出</el-button>
    <el-button @click="back">返回</el-button>
  </div>
  <div class="body">
    <el-descriptions size="mini" :column="1" direction="vertical" border>
      <el-descriptions-item>
        <template slot="label">
          <span style="font-weight: bold;color: black;font-size: 18px;">客户房产信息表</span>
        </template>
        <el-descriptions size="mini" :column="2" border :label-style="{width:'100px'}" :contentStyle="{maxWidth:'300px',wordBreak:'break-all'}">
          <el-descriptions-item label="客户名称">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.customer_name"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="出生日期">
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.start_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择开始时间">
            </el-date-picker>
            至
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.end_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择结束时间">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="证件号码">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.id_card"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="性别">
            <el-checkbox-group size="mini" v-model="where.sexs">
              <el-checkbox label="1">男</el-checkbox>
              <el-checkbox label="2">女</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="房产信息">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.house_name"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="手机">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.phone_number"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="邮寄地址">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.mailing_address"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="邮编">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.zip_code"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="民族">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.nation"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="国籍">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.nationality"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="客户性质">
            <el-checkbox-group size="mini" v-model="where.types">
              <el-checkbox label="1">个人客户</el-checkbox>
              <el-checkbox label="2">企业客户</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="房产类型">
            <el-checkbox-group size="mini" v-model="where.house_type" style="width: 100%;">
              <el-checkbox label="1">住宅</el-checkbox>
              <el-checkbox label="2">车位</el-checkbox>
              <el-checkbox label="3">储藏室</el-checkbox>
              <el-checkbox label="4">商铺</el-checkbox>
              <el-checkbox label="5">写字楼</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="客户房产关系">
            <el-checkbox-group size="mini" v-model="where.status" style="width: 100%;">
              <el-checkbox label="1">业主/租户</el-checkbox>
              <el-checkbox label="2">业主/历史租户</el-checkbox>
              <el-checkbox label="3">业主</el-checkbox>
              <el-checkbox label="4">历史业主/租户</el-checkbox>
              <el-checkbox label="5">历史业主/历史租户</el-checkbox>
              <el-checkbox label="6">历史业主</el-checkbox>
              <el-checkbox label="7">租户</el-checkbox>
              <el-checkbox label="8">历史租户</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <ViewFile ref="ViewFile" />
</div>
</template>

<script>
import AppConfig from "../../../../config/AppConfig";
import ViewFile from "../../Common/ViewFile";

export default {
  name: "CustomerHouse",
  components: {ViewFile},
  inject:['ReportCustomer'],
  data(){
    return{
      where:{
        customer_name:"",
        start_date:"",
        end_date:"",
        id_card:"",
        sexs:[],
        house_name:"",
        phone_number:"",
        mailing_address:"",
        zip_code:"",
        nation:"",
        nationality:"",
        types:[],
        status:['1','2','3'],
        house_type:['1','4','5'],
        project_id:0
      },
      loading:false,
    }
  },
  mounted() {
    this.where.house_name=this.ReportCustomer.house_name;
    this.where.project_id=this.ReportCustomer.project_id;
  },
  methods:{
    back(){
      this.ReportCustomer.customerMenuIndex="CustomerMain";
    },
    getCustomerExcel(ready_type=1){
      const that=this;
      if(!that.where.house_name){
        that.$message.error('请选择项目/房产！')
        return false;
      }
      that.loading=true;
      let where=ERP.reJson(that.where)
      where.status=where.status.join(',');
      where.types=where.types.join(',');
      where.sexs=where.sexs.join(',');
      where.house_type=where.house_type.join(',');
      ERP.postRequest({
        url: "admin/Customer/getCustomerHouseExcel",
        data: where
      }, res => {
        if (res.code) {
          if(ready_type===1){
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:"预览文件",
              src:AppConfig.erp_server+res.data,
              download(){
                // TODO 下载文件逻辑
                window.open(AppConfig.erp_server+res.data)
              }
            })
          }else {
            window.open(AppConfig.erp_server+res.data);
          }
        }
        that.loading = false;
      })
    }
  },
  watch:{
    "ReportCustomer.house_name":function (n,o) {
      this.where.house_name=n;
      this.where.project_id=this.ReportCustomer.project_id;
    }
  }

}
</script>

<style lang="scss" scoped>
.content{
  .header{
    display: flex;
    flex-direction: row;
  }
  .body{
    margin-top: 10px;

    .c-input{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/CustomerHouse.vue